import VendorRequestContainer from "./VendorRequestContainer";
import VendorRequestStore from "./VendorRequestStore";

export default VendorRequestStore(VendorRequestContainer); 